import axiosIS from "@/api/net/axios.js"
import ApiConfig, { baseUrl } from "@/config/apiConfig.js"
import sseRequest from "@/api/net/sse.js";

export default {
  // 订单列表
  // https://rg975ojk5z.feishu.cn/wiki/VowYwm3wKinLR8kZrLZcMXFMnBd
  getRandomPrompt(params) {
    return axiosIS(`${baseUrl}/api/pgc/speech/prompt/generate`, params, { method: "post" })
  },
  generateTtsVoice(params) {
    return axiosIS(`${baseUrl}/api/pgc/voice/generate`, params, { method: "post" })
  },

  generateTtsSpeech(params) {
    return axiosIS(`${baseUrl}/api/pgc/speech/generate`, params, { method: "post" })
  },
  generateTtsSpeecRetry(params) {
    return axiosIS(`${baseUrl}/api/pgc/speech/generate/retry`, params, { method: "post" })
  },
  getTtsSpeechList(params) {
    return axiosIS(`${baseUrl}/api/pgc/speech/list`, params, { method: "get" })
  },
  sendSpeechDelete(params) {
    return axiosIS(`${baseUrl}/api/pgc/speech/delete`, params, { method: "post" })
  },
  saveTtsVoiceinfo(params) {
    return axiosIS(`${baseUrl}/api/pgc/voice/save`, params, { method: "post" })
  },
  editTtsVoiceInfo(params) {
    return axiosIS(`${baseUrl}/api/pgc/voice/edit`, params, { method: "post" })
  },
  deleteTtsVoiceItem(params) {
    return axiosIS(`${baseUrl}/api/pgc/voice/delete`, params, { method: "post" })
  },

  favoriteTtsVoiceinfo(params) {
    return axiosIS(`${baseUrl}/api/pgc/voice/favorite`, params, { method: "post" })
  },
  publishTtsVoiceinfo(params) {
    return axiosIS(`${baseUrl}/api/pgc/voice/publish`, params, { method: "post" })
  },
  getTtsVoiceLibraryData(params) {
    return axiosIS(`${baseUrl}/api/pgc/voice/list`, params, { method: "get" })
  },
  queryTtsVoiceLibraryData(params) {
    return axiosIS(`${baseUrl}/api/pgc/voice/search`, params, { method: "get" }) 
  },
  getTtsVoiceLibrary(params) {
    return axiosIS(`${baseUrl}/api/pgc/voice/list`, params, { method: "get" })
  },
  getTtsVoiceStatus(params) {
    return axiosIS(`${baseUrl}/api/pgc/voice/query`, params, { method: "get" })
  },
}
